document.addEventListener( 'chatlio.ready', function( e ){
    $( '._chat-link' ).removeAttr( 'disabled' );
    $( '._chat-link' ).on('click', function(){
        _chatlio.show( { expanded: true } )
    } );
}, false );
